import { render } from "./PsychicModule.vue?vue&type=template&id=d78d6964&scoped=true"
import script from "./PsychicModule.vue?vue&type=script&lang=js"
export * from "./PsychicModule.vue?vue&type=script&lang=js"

import "./PsychicModule.vue?vue&type=style&index=0&id=d78d6964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d78d6964"]])

export default __exports__